import React from "react";
import { Button } from "antd";
import Particles from "react-particles-js";
import { Mobile, Tablet } from "../utils/Responsive";
import { params } from "../utils/particlesjs-config";
import chemFaxLogo from "../img/logo_chem_fax.png";

const HeroContent = props => {
  return (
    <header {...props}>
      {!props.mobile && (
        <Particles
          width="100%"
          height="50%"
          params={params}
          canvasClassName="particles"
        />
      )}

      <hgroup className="hero-section-text">
        <img
          src={chemFaxLogo}
          alt="Faculty of Chemistry Logo"
          style={{ paddingBottom: "10px", maxWidth: "40px" }}
        />
        <p>University of Belgrade | Faculty of Chemistry</p>
        <h1 className="hero-section-title">
          Organic Chemistry & Biocatalysis Group
        </h1>
        <p className="hero-section-subtitle">
          RESEARCH &bull; TEACH &bull; COLLABORATE
        </p>
      </hgroup>
      <div className="hero-section-contact">
        <Button type="primary" shape="circle" icon="mail" />
        <Button type="primary" shape="circle" icon="twitter" />
        <Button type="primary" shape="circle" icon="instagram" />
      </div>
    </header>
  );
};
const HeroSection = () => {
  return (
    <>
      <Tablet>
        <HeroContent moble="false" className="hero-section" />
      </Tablet>
      <Mobile>
        <HeroContent mobile="true" className="mobile hero-section" />
      </Mobile>
    </>
  );
};

export default HeroSection;
